



































































































































































































































































import {
  computed,
  ref,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  watch,
  onBeforeUnmount,
} from '@vue/composition-api';
import reportSvg from '@/assets/images/health-report.svg';
import reportSolidSvg from '@/assets/images/health-report-solid.png';
import missionSvg from '@/assets/images/health-mission.svg';
import missionSolidSvg from '@/assets/images/health-mission-solid.svg';
import planSvg from '@/assets/images/health-plan.svg';
import planSolidSvg from '@/assets/images/health-plan-solid.png';
import recordSvg from '@/assets/images/record.svg';
import recordSolidSvg from '@/assets/images/record-solid.svg';
import Bubble from './components/bubble.vue';
import TagFilterDialog from '@/views/patient/list/widgets/tagFilterDialog.vue';
import patientSelectPop from './patientSelectPop.vue';
import patientTagSelectPop from './patientTagSelectPop.vue';
import dayjs from 'dayjs';
import { apiGetPatientPortraitTag } from '@/services/user';
import { getPromptTemplates, getHistory, stopGenerate, chatFetch, getUserChatSessionId } from '@/services/AI';
import richTextInput from './components/richTextInput.vue';
import { Message } from '@/layout/type';
import toBottomPng from '@/assets/images/btn-to-bottom.png';
import toast from './components/toast.vue';
import { useResizable } from './useResizable';
import { getDoctorInfo } from '@/utils/utils';
import { AIFunctionType } from '@/const/business';

import deepSeekLoading from './components/deepSeekLoading.vue';
import ordinaryAiLoading from './components/ordinaryAiLoading.vue';
export default defineComponent({
  components: {
    Bubble,
    TagFilterDialog,
    patientSelectPop,
    patientTagSelectPop,
    richTextInput,
    toast,
    deepSeekLoading,
    ordinaryAiLoading,
  },
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    isEducationShow: String,
    isPlanShow: String,
    isSummaryShow: String,
    isRecordShow: String,
  },
  setup(props, { root, emit }) {
    const handleClose = () => {
      emit('change', false);
    };

    const computedShow = computed({
      get() {
        return props.show;
      },
      set() {
        handleClose();
      },
    });
    const doctorInfo = ref<any>({});

    const isModalShow = computed(() => tagSelectDialogShow.value || patientSelectPopShow.value || patientTagSelectPopShow.value);

    const isActive = ref(''); // 当前选中的tab，value

    const toolbar = [
      {
        name: '档案智问',
        icon: recordSvg,
        value: AIFunctionType.healthRecord,
        activeIcon: recordSolidSvg,
        show: props.isRecordShow === 'Y',
      },
      {
        name: '健康报告',
        icon: reportSvg,
        value: AIFunctionType.healthReport,
        activeIcon: reportSolidSvg,
        show: props.isSummaryShow === 'Y',
      },
      {
        name: '健康宣教',
        icon: missionSvg,
        value: AIFunctionType.healthEducation,
        activeIcon: missionSolidSvg,
        show: props.isEducationShow === 'Y',
      },
      {
        name: '健康计划',
        icon: planSvg,
        value: AIFunctionType.healthPlan,
        activeIcon: planSolidSvg,
        show: props.isPlanShow === 'Y',
      },
    ];
    const planSelected = ref('随访计划');
    const planList = ['随访计划', '运动计划', '饮食计划', '自定义'];
    const planTypeChange = (val) => {
      const plan = planList.find(item => item === val);
      if (plan) {
        planSelected.value = plan;
      } else {
        planSelected.value = '自定义';
      }
    };

    const type = ref('custom');

    const typeList = [
      { value: 'label', name: '按标签' },
      { value: 'patient', name: '按患者' },
      { value: 'custom', name: '自定义' },
    ];
    const activeTool = computed(() => toolbar.find(item => item.value === isActive.value));

    const tagSelectDialogShow = ref(false);
    const tagSelectedList = ref([]);
    const getTagFilterParams = (params) => {
      const { systemTags, customTags } = params;

      tagSelectedList.value = systemTags
        .concat(customTags)
        ?.map(item => item.tagValues)
        .flat();
    };

    const patientSelectPopShow = ref(false);
    interface PatientItem {
      patientName: string;
      patientId: string;
      patientGender: string;
      patientAge: number;
    }
    const currentPatient = ref<PatientItem | any>({});
    const selectList = computed(() => root.$store.state.selectList); // 选中患者列表
    const selectPatientId = computed(() => root.$store.state.selectPatientId); // 当前选中患者id
    const setDefaultPatient = (newList, newId) => {
      let newPatient;
      if (newId) newPatient = newList.find(item => item.patientId === newId);
      else newPatient = newList[0];
      console.log(newPatient, 'newId', newId, 'newList', newList);

      if (!newPatient) return;

      const { patientId, patientName, patientAge, patientGender } = newPatient;
      currentPatient.value = {
        patientId,
        patientName,
        patientAge,
        patientGender,
      };
      type.value = 'patient';
    };
    watch([selectList, selectPatientId], ([newList, newId]) => {
      if (!currentPatient.value?.patientId && computedShow.value) {
        setDefaultPatient(newList, newId);
        if (isActive.value === AIFunctionType.healthRecord && currentPatient.value.patientId) {
          handleClearContext({ switchPatient: true });
          messageList.value.push({
            type: 'clearContext',
            text: `已切换患者为${currentPatient.value.patientName}`,
            createTime: dayjs().format('YYYY/MM/DD HH:mm'),
            timestamp: dayjs().valueOf(),
          });
          scrollToBottom();
        }
      }
    });
    watch(currentPatient, () => {
      if (computedShow.value) getPatientPortraitTag();
    });

    const getDesensitizeName = computed(() => {
      if (!currentPatient.value.patientName) return currentPatient.value.patientName;

      // 获取姓和名
      const surname = currentPatient.value.patientName.charAt(0); // 姓
      const givenName = currentPatient.value.patientName.slice(1); // 名

      // 处理名的脱敏
      const maskedGivenName = givenName.length > 0 ? `*${givenName.slice(1)}` : '';

      // 返回脱敏后的姓名
      return surname + maskedGivenName;
    });
    const isQuestionClick = ref(false);
    const curQuestion = ref('');
    const handleQuestionClick = (question) => {
      isActive.value = AIFunctionType.healthRecord;
      console.log(question, 'question', richTextInputRef.value?.editorRef.innerText);

      if (!currentPatient.value.patientId) {
        patientSelectPopShow.value = true;
        isQuestionClick.value = true;
        curQuestion.value = question;
      } else {
        sendMessage(richTextInputRef.value?.editorRef.innerText + question);
      }
    };
    const handleClearContext = async ({ switchPatient = false }) => {
      await getUserChatSessionId({
        newSession: true, // 是否新建一个session true 新建 false 否
        patientId: currentPatient.value.patientId, // 患者的id
        switchPatient, // 是否展示切换患者文案 true 展示 false 不展示
      });
    };

    const richTextInputRef = ref<any>(null);

    const getPatient = (patient) => {
      currentPatient.value = patient;
      if (isActive.value === AIFunctionType.healthRecord) {
        handleClearContext({ switchPatient: true });
        messageList.value.push({
          type: 'clearContext',
          text: `已切换患者为${patient.patientName}`,
          createTime: dayjs().format('YYYY/MM/DD HH:mm'),
          timestamp: dayjs().valueOf(),
        });
        scrollToBottom();
      }
      if (isQuestionClick.value) {
        isQuestionClick.value = false;
        sendMessage(richTextInputRef.value?.editorRef.innerText + curQuestion.value);
      }
    };
    const patientTags = ref({});

    const selectedPatientTagList = ref<any[]>([]);
    const getPatientPortraitTag = async () => {
      const { patientTagInfo }: any = await apiGetPatientPortraitTag({
        patientId: currentPatient.value.patientId,
      });
      const { baseInfo, diseaseInfo, healthHistory, healthIndicators, lifestyle } = patientTagInfo;
      patientTags.value = {
        baseInfo,
        diseaseInfo,
        healthHistory,
        healthIndicators,
        lifestyle,
      };
      const localStorageData = JSON.parse(localStorage.getItem('patientTags') || '{}');
      const tagList = localStorageData[doctorInfo.value.userId]?.[currentPatient.value.patientId];

      if (tagList) {
        // 过滤tagList，只保留存在于patientTags中的项
        const allPatientTags = Object.values(patientTags.value).flat();
        selectedPatientTagList.value = tagList.filter(item => allPatientTags.some(tag => tag === item));
        return;
      }
      selectedPatientTagList.value = Object.values(patientTags.value).flat();
    };

    const toastShow = ref(false);
    // 档案智问
    const recordRelatedList = [
      { value: 'record', name: '健康档案' },
      { value: 'label', name: '患者标签' },
    ];
    const recordRelated = ref('record');

    const patientTagSelectPopShow = ref(false);
    const getPatientTag = (tagList) => {
      selectedPatientTagList.value = tagList;
    };

    const loading = ref(false);
    const isTyping = ref(false);
    const chatToken = ref('');

    const loopToReadStream = async (response: Response, message: Message) => {
      loading.value = false;
      isTyping.value = true;
      if (aiModelType.value === 'deepSeek') message.isThinking = true;
      const list: any = [];
      try {
        const reader = response.body?.getReader();
        const decoder = new TextDecoder('utf-8');

        if (!reader) return;
        let buffer = '';
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            console.log('Stream complete');
            isTyping.value = false;
            message.isThinking = false;
            if (aiModelType.value === 'deepSeek') {
              const lastMessage = list.slice(-1)[0];
              message.reasoningSecond = lastMessage.data.reasoningSecond;
            }
            return;
          }

          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          // console.log('buffer', buffer);

          const lines = buffer.split('\n');
          buffer = lines.pop() || '';

          const jsonObjects = lines.map((item) => {
            try {
              return JSON.parse(item);
            } catch (error) {
              console.error('JSON parse error:', error, item);
              return {};
            }
          });
          list.push(...jsonObjects);

          const concatenatedMsg = jsonObjects
            .map((obj) => {
              if (!obj.data) return '';
              if (obj.data.status === 'token') {
                chatToken.value = obj.data.msg;
                return '';
              }
              if (obj.data.docs) {
                message.quote = obj.data.docs;
                return '';
              }
              if (obj.data.guessedQuestions) {
                message.questions = obj.data.guessedQuestions;
                return '';
              }
              isTyping.value = true;
              return obj.data?.msg;
            })
            .join('');
          const reasoningContent = jsonObjects
            .map((obj) => {
              if (!obj.data) return '';
              return obj.data?.reasoningContent || '';
            })
            .join('');
          message.text += concatenatedMsg;
          message.reasoningContent += reasoningContent;
          scrollToBottom();
        }
      } catch (error) {
        console.error('Stream error:', error);
        isTyping.value = false;
        message.isThinking = false;
        loading.value = false;
      }
    };

    const inputText = ref('');

    const defaultWelcomeMsg = {
      timestamp: Date.now(),
      text: '**我是您的AI健康助手，一站式解答疑问、提供健康建议、助您提升工作效率，我可以帮您：**\n- 根据患者信息生成健康报告\n- 根据患者特征生成健康计划\n- 生成个性化健康宣教内容',
      role: 'AI',
      type: 'welcome',
    };
    const guessQuestions = computed(() => promptTemplateList.value.find(item => item.type === AIFunctionType.healthRecord)?.guessQuestion) || [];
    const recordWelcomeMsg = reactive({
      timestamp: Date.now(),
      text: '档案智问为您提供患者数据自由问答服务。请先选定一名患者，即可直接向我提问，我可以针对患者帮您查病史、找方案、分析特征。',
      role: 'AI',
      type: 'welcome',
      usage: AIFunctionType.healthRecord,
      questions: computed(() => guessQuestions.value),
      tip: '常见提问',
    });

    const welcomeMsg = computed(() => {
      // 添加触发更新的依赖项
      const trigger = isActive.value; // 显式声明依赖
      return isActive.value === AIFunctionType.healthRecord
        ? { ...recordWelcomeMsg, timestamp: Date.now() }
        : { ...defaultWelcomeMsg, timestamp: Date.now() };
    });

    const currentPage = ref(0);
    const pageSize = 5;
    const totalQA = ref(0);
    const messageList = ref<Message[]>([]);
    const messageLoading = ref(false);
    const getHistoryList = async () => {
      messageLoading.value = true;
      const { total, aiMessages } = await getHistory({
        pageSize, // 每页需要多少个 不传的的话默认是20条， pagesize 取值范围是 1--200
        currentPage: currentPage.value, // 当前是第几页 从0开始计算
        type: [], // summary 健康总结, plan 健康计划 education 健康宣教，如果不传的话 表示拉取所有的
      });
      totalQA.value = total;
      aiMessages?.forEach((item) => {
        const {
          createTime,
          prompt,
          type,
          aiAssistantResponse,
          aiTemplateId,
          model,
          reasoningSecond,
          reasoningContent,
          docs,
          guessedQuestions,
          patientId,
          showMessage,
        } = item;
        if (type === 'clearContext') {
          const msg = {
            timestamp: createTime,
            createTime: dayjs(createTime).format('YYYY/MM/DD HH:mm'),
            text: showMessage,
            role: '',
            type,
          };
          messageList.value.unshift(msg);
          return;
        }
        if (!aiAssistantResponse) return;
        const question = {
          timestamp: createTime,
          text: prompt,
          role: 'me',
          usage: type,
        };
        const answer = {
          timestamp: createTime,
          text: aiAssistantResponse,
          role: 'AI',
          usage: type,
          aiTemplateId,
          model,
          reasoningSecond,
          isFold: false,
          reasoningContent,
          quote: docs,
          questions: guessedQuestions,
          patientId,
        };
        messageList.value.unshift(question, answer);
      });

      messageLoading.value = false;
    };

    const aiModelType = ref('hunyuan');
    // 默认对话回答
    const sendMessage = async (msg) => {
      const text = msg.trim();
      if (loading.value) return;
      if (text) {
        loading.value = true;
        const message = {
          timestamp: dayjs().valueOf(),
          text,
          role: 'me',
        };
        messageList.value.push(message);
        inputText.value = '';
        // if (!oneClickSendText) inputFocus();
        scrollToBottom();
        const answer = reactive({
          timestamp: dayjs().valueOf(),
          text: '',
          role: 'AI',
          content: [],
          usage: isActive.value,
          reasoningContent: '',
          reasoningSecond: '',
          isThinking: false,
          isFold: false,
          patientId: currentPatient.value.patientId,
        });

        chatFetch({
          type: isActive.value, // summary 健康总结, plan 健康计划 education 健康宣教
          patientId: currentPatient.value.patientId, // 如果选了患者 表示患者id
          prompt: message.text, // 表示医生的提问问题
          aiTemplateId: currentTemplate.value.id, // 对应使用的模版id,
          modelType: aiModelType.value,
          onlyUseLabel: recordRelated.value === 'label',
        })
          .then((response) => {
            messageList.value.push(answer);
            console.log('%c Line:544 🍬 messageList.value', 'color:#ed9ec7', messageList.value);
            return loopToReadStream(response as Response, answer);
          })
          .catch((error) => {
            console.error('Fetch Error:', error);
            isTyping.value = false;
            loading.value = false;
          });
      }
    };

    const onSend = (text) => {
      sendMessage(text);
    };
    // 重新提问
    const regenerate = (aiTemplateId) => {
      if (loading.value) return;
      loading.value = true;
      scrollToBottom();

      let lastMineMessage;

      for (let i = messageList.value.length - 1; i >= 0; i--) {
        if (messageList.value[i].role === 'me') {
          lastMineMessage = messageList.value[i];
          break; // 找到后退出循环
        }
      }
      const type = messageList.value[messageList.value.length - 1]?.usage;

      chatFetch({
        // summary 健康总结, plan 健康计划 education 健康宣教
        type,
        patientId: currentPatient.value.patientId, // 如果选了患者 表示患者id
        prompt: lastMineMessage?.text || '', // 表示医生的提问问题
        aiTemplateId: aiTemplateId || currentTemplate.value.id, // 对应使用的模版id,
        modelType: aiModelType.value,
        regeneration: true,
        onlyUseLabel: recordRelated.value === 'label',
      })
        .then((response) => {
          const lastMessage = messageList.value.slice(-1)[0];
          lastMessage.text = '';
          lastMessage.content = [];
          return loopToReadStream(response as Response, lastMessage);
        })
        .catch((error) => {
          console.error('Fetch Error:', error);
          isTyping.value = false;
          loading.value = false;
        });
    };

    const stopping = ref(false);
    const stopTyping = async () => {
      if (stopping.value) return;
      stopping.value = true;
      const res = await stopGenerate({ token: chatToken.value });
      if (res) {
        isTyping.value = false;
        stopping.value = false;
      }
    };

    const messageContainerRef = ref<HTMLDivElement | null>(null);
    const isAtBottom = ref(true);
    const isMessageAllLoaded = ref(false);
    const scrollToBottom = async () => {
      await nextTick();
      if (messageContainerRef.value) {
        messageContainerRef.value.scrollTop = messageContainerRef.value.scrollHeight;
      }
    };
    const handleScroll = async () => {
      const container = messageContainerRef.value;
      if (container) {
        const { scrollTop, scrollHeight, clientHeight } = container;

        // 是否在底部
        isAtBottom.value = scrollTop + clientHeight + 1 >= scrollHeight;
        // 滑动到顶部加载更多历史消息
        if (scrollTop === 0) {
          if (totalQA.value && messageList.value.length >= totalQA.value * 2) {
            isMessageAllLoaded.value = true;
            return;
          }
          const oldHeight = container.scrollHeight;
          currentPage.value += 1;
          await getHistoryList();
          await nextTick();
          const newHeight = container.scrollHeight;
          container.scrollTop = newHeight - oldHeight;
        }
      }
    };

    const promptTemplateList = ref<any[]>([]);
    const currentTemplate = ref<any>({});
    const getPromptTemplateList = async () => {
      const { aiTemplateList } = await getPromptTemplates();
      promptTemplateList.value = aiTemplateList || [];
    };
    const getTemplate = (type, subType) => {
      let template;
      if (type === AIFunctionType.healthReport || type === AIFunctionType.healthRecord) template = promptTemplateList.value.find(item => item.type === type);
      else template = promptTemplateList.value.find(item => item.type === type && item.subType === subType);
      if (template) {
        currentTemplate.value = template;
        inputText.value = template.userPrompt;
      }
    };

    watch([() => isActive.value, () => type.value], ([newActive, newType]) => {
      if (!newActive) return;
      if ((newActive === AIFunctionType.healthReport || newType === 'patient') && !currentPatient.value.patientId) {
        patientSelectPopShow.value = true;
      } else if (
        (newActive === 'education' || newActive === 'plan')
        && newType === 'label'
        && tagSelectedList.value.length === 0
      ) {
        tagSelectDialogShow.value = true;
      }
      getTemplate(newActive, newType);
    });
    watch(isActive, (newActive) => {
      if (newActive === AIFunctionType.healthRecord && currentPatient.value.patientId) {
        handleClearContext({ switchPatient: false });
        messageList.value.push({
          type: 'clearContext',
          text: '',
          createTime: dayjs().format('YYYY/MM/DD HH:mm'),
          timestamp: dayjs().valueOf(),
        });
      }
    });

    watch(
      () => props.show,
      (newValue: boolean) => {
        if (newValue) {
          updateLeft();
          scrollToBottom();
          console.log('open', root.$route.path, selectList.value, selectPatientId.value);
          if (currentPatient.value.patientId) getPatientPortraitTag();
          else {
            if (root.$route.path === '/default/detail') {
              setDefaultPatient(selectList.value, selectPatientId.value);
              if (isActive.value === AIFunctionType.healthRecord && currentPatient.value.patientId) {
                handleClearContext({ switchPatient: true });
              }
            }
          }
        } else {
        }
      },
    );

    onMounted(async () => {
      getHistoryList();
      getPromptTemplateList();
      scrollToBottom();
      window.addEventListener('resize', updateLeft);
      doctorInfo.value = await getDoctorInfo();
    });

    const updateLeft = () => {
      if (!computedShow.value) return;
      if (width.value > window.innerWidth * 0.9) {
        width.value = window.innerWidth * 0.9;
      }
      console.log('resize', width.value, left.value, window.innerWidth, window.innerWidth - width.value - 40);
      nextTick(() => {
        if (left.value + width.value > window.innerWidth || left.value < 0) {
          left.value = window.innerWidth - width.value - 40;
        }
      });
    };

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateLeft);
    });

    // 顶部拖拽逻辑
    const isDragging = ref(false);
    const isHover = ref(false);
    const offset = { x: 0, y: 0 };
    const top = ref(100);
    const left = ref<any>(window.innerWidth * 0.7);

    const startDrag = async (event) => {
      await nextTick();
      isDragging.value = true;
      const rect = dialogRef.value.getBoundingClientRect();
      offset.x = event.clientX - rect.left;
      offset.y = event.clientY - rect.top;
      console.log(offset.x, offset.y, left.value, rect.left, event.clientX, event.clientY, 'startDrag');

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = (event) => {
      if (isDragging.value) {
        let newTop = event.clientY - offset.y;
        let newLeft = event.clientX - offset.x;

        // 限制对话框在页面内移动
        if (newTop < 0) newTop = 0; // 不允许超出顶部
        if (newLeft < 0) newLeft = 0; // 不允许超出左侧
        if (newTop + height.value > window.innerHeight) {
          newTop = window.innerHeight - height.value; // 不允许超出底部
        }
        if (newLeft + width.value > window.innerWidth) {
          newLeft = window.innerWidth - width.value; // 不允许超出右侧
        }

        top.value = newTop;
        left.value = newLeft;
      }
    };

    const onMouseUp = () => {
      isDragging.value = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    const onMouseLeave = () => {
      isDragging.value = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    // 弹窗拉伸逻辑

    const dialogRef = ref<any>(null);
    const { width, height, startResize } = useResizable(dialogRef, 408, 700, isModalShow);

    const handleBerClick = (value) => {
      isActive.value = value;
      aiModelType.value = 'hunyuan';
    };
    return {
      computedShow,
      isHover,
      top,
      left,
      toolbar,
      isActive,
      messageList,
      activeTool,
      planSelected,
      planList,
      type,
      typeList,
      tagSelectDialogShow,
      tagSelectedList,
      patientSelectPopShow,
      currentPatient,
      patientTagSelectPopShow,
      inputText,
      selectedPatientTagList,
      patientTags,
      isTyping,
      loading,
      messageContainerRef,
      currentTemplate,
      welcomeMsg,
      getDesensitizeName,
      toBottomPng,
      isAtBottom,
      messageLoading,
      isMessageAllLoaded,
      totalQA,
      stopping,
      toastShow,
      width,
      height,
      dialogRef,
      doctorInfo,
      isModalShow,
      startResize,
      startDrag,
      onMouseUp,
      onMouseLeave,
      getTagFilterParams,
      getPatient,
      onSend,
      getPatientTag,
      regenerate,
      stopTyping,
      scrollToBottom,
      handleScroll,
      planTypeChange,
      AIFunctionType,
      aiModelType,
      handleBerClick,
      recordRelatedList,
      recordRelated,
      handleQuestionClick,
      handleClearContext,
      guessQuestions,
      richTextInputRef,
    };
  },
});
